module.exports = "/packs/as_img01-37d18d9a71990d9fd2b04b1566cb102d.png";